import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import _ from 'lodash';
import numeral from 'numeral';
import { BigNumber } from 'bignumber.js';
import { VictoryLine } from 'victory';
import bitcoinData from '../data/bitcoinChart.json';
import ethereumData from '../data/ethereumChart.json';
import neoData from '../data/neoChart.json';
import stellarData from '../data/stellarChart.json';
import { Colors } from '../constants';

const Row = styled.div`
  position: relative;
  display: flex;
  height: 60px;
  margin-bottom: 2px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const Bg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: ${props => props.theme.fav.rowBg};
  opacity: 0.8;
`;

const Left = styled.div`
  flex: 1;
  padding: 3px 0 3px 5px;
`;

const Middle = styled.div`
  flex: 1;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
`;

const Symbol = styled.div`
  color: ${props => props.theme.fav.title};
  font-size: 14px;
`;

const Price = styled.div`
  color: ${props => props.theme.fav.title};
  font-size: 20px;
`;

const SubPrice = styled.div`
  color: ${props => props.theme.fav.title};
  font-size: 14px;
`;

const DiffPercent = styled.div`
  font-size: 14px;
`;

const DiffBox = styled.div`
  background: ${props => (+props.value >= 0 ? Colors.statGreen : Colors.statOrange)};
  padding: 8px 10px;
  border-radius: 3px;
  color: #fff;
  min-width: 50px;
  text-align: center;
  margin: 10px;
`;

const FavRowX = ({
  theme, coin: {
    symbol, price, diff, diffPercent, market, high, low, vol,
  },
}) => {
  const charts = [bitcoinData, ethereumData, neoData, stellarData];
  const data = _.sample(charts).price_usd.map(c => ({ x: c[0], y: c[1] }));
  const priceUSD = BigNumber(price).times(10500);
  const priceUSDFmt = numeral(priceUSD).format('$0,0.00');
  const priceExtra = symbol !== 'BTC' ? priceUSDFmt : '';
  const btcDollarSign = symbol === 'BTC' ? '$' : '';
  return (
    <ThemeProvider theme={theme}>
      <Row>
        <Bg />
        <Left>
          <Symbol>{symbol}</Symbol>
          <Price>
            {btcDollarSign}
            {price}
          </Price>
          <SubPrice>{priceExtra}</SubPrice>
        </Left>
        <Middle>
          <VictoryLine
            style={{
              data: { stroke: +diffPercent >= 0 ? Colors.statGreen : Colors.statOrange },
            }}
            data={data}
          />
        </Middle>
        <Right>
          <DiffBox value={+diffPercent}>
            <DiffPercent value={+diffPercent}>{diffPercent}%</DiffPercent>
          </DiffBox>
        </Right>
      </Row>
    </ThemeProvider>
  );
};

export default withTheme(FavRowX);



// WEBPACK FOOTER //
// ./src/components/FavRowX.js